import { Modal } from 'antd'

import { Button } from '@weareberyl/design-system'

import {
  InvoiceDocument,
  useRefundInvoiceExcessBalanceMutation,
  type InvoiceQuery_invoice_JourneyInvoice,
} from '~/gql/generated/graphql'
import { useScheduleRefresh } from '~/hooks/useScheduleRefresh'
import { generateResultMessage } from './Refund'

type Props = {
  invoiceId: InvoiceQuery_invoice_JourneyInvoice['id']
  balance: InvoiceQuery_invoice_JourneyInvoice['currency_balance']
}
const RefundExcess = ({ invoiceId, balance }: Props) => {
  const scheduleRefresh = useScheduleRefresh([InvoiceDocument])
  const description = 'Refunding excess balance'
  const [doRefundRequest, { loading }] = useRefundInvoiceExcessBalanceMutation({
    variables: { id: invoiceId, description },
    onCompleted: result => {
      if (result.refund_invoice_excess_balance?.currency?.status) {
        generateResultMessage(
          result.refund_invoice_excess_balance.currency.status,
          'Refund currency',
          result.refund_invoice_excess_balance.currency.message ?? null,
        )
      }
      // Reload the invoice query in a bit, after webhook has had time to arrive
      scheduleRefresh()
    },
  })

  const onPress = () => {
    Modal.confirm({
      onOk: doRefundRequest,
      title: `Refund ${balance?.formatted_amount}`,
    })
  }

  return (
    <Button
      onPress={onPress}
      testID="refund-excess-btn"
      title="Refund excess balance"
      variant="primary"
      loading={loading}
      mt={2}
      mr={3}
    />
  )
}

export default RefundExcess
